module.exports = __webpack_public_path__ + "static/img/Bachelor_010405.8e2ff85.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010405.jpg
// module id = 161
// module chunks = 0